import React, { type FC } from "react";
import "./PlayfulBounce.sass";
import { tt } from "../../../utils/i18n/i18n";
import KC_Heading3 from "../../../designsystem/typography/KC-Heading/KC_Heading3";

interface Props {
  loading: boolean;
}

/**
 * https://css-loaders.com/bouncing/
 * Number 10
 * @param props
 * @constructor
 */
const PlayfulBounce: FC<Props> = (props: Props) => {
  if (!props.loading) {
    return null;
  }

  return (
    <div className="loader-container">
      <div className="loader"></div>
      <div className="loader-text">
        <KC_Heading3 text={tt("loading")} />
      </div>
    </div>
  );
};

export default PlayfulBounce;
